import React from "react";

const MyNftTab = () => {
    return (
        <div>

        </div>
    )
}

export default MyNftTab